<template>
    <div class=" grid gap-y-3">
        <!-- <div class="flex items-center">
            <p class="text-[1rem] font-[600] mr-2">Please select required options:</p>
            <v-btn-toggle v-model="serverType" color="deep-purple-accent-3" group mandatory rounded="0"
                style="height: 40px;" class="border">
                <v-btn value="XProxy" class=" bg-white text-black h-full" style="outline: none; height: 100%;">
                    <img src="../../../assets/openVPN-not.png" />
                    <p class="text-xs pl-2">HTTP & SOCKS5</p>
                </v-btn>
                <v-btn value="ProxySmart" class=" bg-white text-black h-full" style="outline: none; height: 100%;">
                    <img src="../../../assets//openVPN.png" />
                    <p class="text-xs pl-2">HTTP & SOCKS5 With OpenVPN</p>
                </v-btn>
            </v-btn-toggle>
        </div> -->
        <div v-if="name !== 'ausproxies'">   <!-- AusProxies sells Australia only: the country is picked automatically -->
            <div class = "flex items-center">
                <p class="font-bold py-2">{{ t('buy.country') }}</p>
                <div class="w-full" v-if="name === 'global' && !adminPreview">
                    <v-btn 
                        class="btn btn-primary btn-sm float-end"
                        :disabled="!selectedDetails.country"
                        data-bs-toggle="modal"
                        data-bs-target="#newLocationModal"
                    >
                        {{ t('buy.requestNewLocation') }}
                    </v-btn>
                    <v-btn 
                        class="btn btn-primary btn-sm float-end mr-2"
                        :disabled="!(selectedDetails.country && selectedDetails.isp && selectedDetails.city)"
                        data-bs-toggle="modal"
                        data-bs-target="#newStockModal"
                    >
                        {{ t('buy.requestNewStock') }}
                    </v-btn>
                </div>
            </div>
            <div class="overflow-hidden bg-white rounded-0 border-0 p-20">
                <div v-for="country in countryList" v-bind:key="country"
                    @click="selectCountry(country.name, country.proxy_count)" class="cursor-pointer float-left text-black"
                    rounded="0">
                    <div class=" justify-between items-center p-3">
                        <div class="relative rounded  shadow-md   hover:scale-110  duration-500  border border-black"
                            :class="selectedDetails.country === country.name ? 'scale-110 shadow-blue-500' : selectedDetails.country ? ' contrast-75' : ''">
                            <img :src="country.iconurl" class="relative rounded" width="120" height="100" />
                            <span
                                class="position-absolute z-10 start-100 text-[16px] min-w-[30px] top-0 translate-middle badge rounded-pill flex items-center justify-center aspect-square"
                                :class="(Number(country.x_proxy) + Number(country.proxysmart) + Number(country.proproxyui || 0)) > 0 ? 'bg-success' : 'bg-danger'">
                                {{ (Number(country.x_proxy) + Number(country.proxysmart) + Number(country.proproxyui || 0)) }}
                            </span>
                            <div
                                class="w-full flex px-2 absolute bottom-0 rounded-b border-t bg-gray text-xs py-1 font-bold z-0">
                                <div class="mx-auto px-2 text-center" style="font-size: 10px; line-height: 1.25;">
                                    <!-- 中文: Chinese name on top, the English one under it -->
                                    <div v-if="countryZh(country.name)" style="font-size: 12px;">{{ countryZh(country.name) }}</div>
                                    <div :style="countryZh(country.name) ? 'font-size: 9px; font-weight: 500;' : ''">{{ country.name }}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- <p class="text-[10px] text-center">HTTP & SOCKS5: {{ country.x_proxy }}</p>
                    <p class="text-[10px] text-center">HTTP & SOCKS5 /W VPN: {{ country.proxysmart }}</p> -->
                </div>
            </div>
        </div>
        <!-- replaces the old "Need OpenVPN ...? YES / NO" question: every location of every server type is listed,
             and these toggles narrow them to the servers that offer the chosen features (in stock or not) -->
        <FeatureFilterBar :model-value="featureFilter" @update:model-value="applyFeatureFilter" />
        <p v-if="featureFilter.length && selectedDetails.country && !ispList.length && filterLoaded" class="feature-filter-empty">{{ t('featureFilter.none', { country: countryZh(selectedDetails.country) || selectedDetails.country }) }}</p>
        <div v-if="serverType" class="flex flex-col gap-4 pb-4 2xl:flex-row 2xl:space-x-2 2xl:gap-0">
            <div class="w-full 2xl:w-1/2">
                <p class="font-bold py-2">{{ t('buy.isp') }}</p>
                <div class="overflow-hidden bg-white rounded-0 border-10 p-20">

                    <div v-for="isp in ispList" v-bind:key="isp" @click="selectedISP = isp.isp"
                        class="cursor-pointer float-left box-border" rounded="0">
                        <div class=" justify-between  items-center p-3 text-black">
                            <div class="relative rounded  shadow-md w-full  hover:scale-110  duration-500  border border-black"
                                :class="selectedDetails.isp === isp.isp ? 'scale-110 shadow-blue-500' : selectedDetails.isp ? 'opacity-50 ' : ''">
                                <img :src="isp?.isp_image ? backendUrl + isp?.isp_image : 'https://webcolours.ca/wp-content/uploads/2020/10/webcolours-unknown.png'"
                                    class="relative rounded-t object-cover" style="aspect-ratio: 1/1;" width="100"
                                    height="100">
                                <span
                                    class="position-absolute top-full start-100 translate-middle badge rounded-pill flex items-center justify-center aspect-square"
                                    :class="isp.proxy_count > 0 ? 'bg-success' : 'bg-danger'">
                                    {{ isp.proxy_count }}
                                </span>
                                <div
                                    class="w-full flex justify-between px-3 bottom-0 rounded-b  z-10 bg-gray text-xs py-1 font-bold">
                                    <div class="" style="font-size: 10px;">
                                        {{ isp.isp }}
                                        <div v-if="isp.max_speed_mbps" class="isp-speed">{{ t('plan.speedShort', { n: isp.max_speed_mbps }) }}</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <p class="font-bold py-2">{{ t('buy.city') }}</p>
                <div class="city-panel p-4">
                    <div v-for="group in cityGroups" v-bind:key="group.key" class="mb-4 last:mb-0">
                        <p class="city-group-label">{{ group.label }}</p>
                        <div class="lg:flex gap-x-4 gap-y-3 flex-wrap">
                            <div v-for="city in group.items" v-bind:key="cityKey(city)" class="w-full py-2 lg:w-fit flex justify-center">
                                <button type="button"
                                    class="city-card"
                                    @click="selectCity(city)"
                                    :class="{ 'is-selected': selectedCityKey === cityKey(city), 'is-empty': Number(city.count) === 0 }"
                                    :title="city.next_available_at ? formatNextAvailableTitle(city.next_available_at) : city.city">
                                    <p class="city-card__name">{{ cityZh(city.city) || city.city }}</p>
                                    <p v-if="cityZh(city.city)" class="city-card__en">{{ city.city }}</p>
                                    <p v-if="Number(city.count) === 0 && city.next_available_at" class="city-card__next">
                                        {{ t('buy.nextExpiry', { time: formatNextAvailable(city.next_available_at) }) }}
                                    </p>
                                    <span
                                        class="city-card__count"
                                        :class="Number(city.count) > 0 ? 'is-ok' : 'is-empty'">
                                        {{ city.count }}
                                    </span>
                                </button>

                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="w-full 2xl:w-1/2">
                <p class="package-section-title font-bold py-1">{{ t('buy.package') }}</p>
                <div class="buy-proxy-package-panel p-4"
                    v-if="selectedDetails.country && selectedDetails.isp && selectedDetails.city">
                    <!-- where and what is in stock, once, above the plans -->
                    <div class="buy-proxy-package-head">
                        <span class="buy-proxy-package-head__title">{{ t('buy.chooseAPackage') }}</span>
                        <span class="buy-proxy-package-head__where">
                            <v-icon icon="mdi-map-marker-outline" size="15"></v-icon>
                            {{ [name === 'ausproxies' ? null : (countryZh(selectedDetails.country) || selectedDetails.country), cityZh(selectedDetails.city) || selectedDetails.city, selectedDetails.isp].filter(Boolean).join(' · ') }}
                            · <span :class="selectedCityHasStock ? 'text-ok' : 'text-warn'">{{ selectedCityHasStock ? t('buy.inStock', { n: Number(selectedCity?.count || 0) }) : t('buy.outOfStock') }}</span>
                        </span>
                    </div>
                    <div class="buy-proxy-package-grid grid grid-cols-1 md:grid-cols-3 gap-3 pt-3">
                        <PackagePlanCard
                            v-for="option in packageOptions"
                            :key="option.key"
                            :plan="option.plan"
                            :period="option.key"
                            :selected-details="selectedDetails"
                            :selected="selectedPlan === option.key"
                            :disabled="!selectedCityHasStock"
                            :daily-price="Number(plans.daily?.price) || 0"
                            :action-label="t('buy.select')"
                            :selected-action-label="adminPreview ? 'Preview purchase' : t('buy.purchase')"
                            @select="selectPlan(option.key)"
                            @action="purchasePlan(option.key)"
                        />
                    </div>
                    <!-- out of stock: offer an email when this location is available again -->
                    <StockAlertBox v-if="!selectedCityHasStock && selectedCity && !adminPreview"
                        :country="selectedDetails.country" :isp="selectedDetails.isp" :city="selectedDetails.city"
                        :is-ipv6="selectedDetails.is_ipv6 === true"
                        :place="[selectedDetails.isp, cityZh(selectedDetails.city) || selectedDetails.city].filter(Boolean).join(' · ')" />
                    <p v-if="adminPreview" class="buy-proxy-package-foot">
                        <v-icon icon="mdi-eye-outline" size="14"></v-icon>
                        This is exactly what a customer sees, filter included. "Preview purchase" opens the real purchase window so you can test quantity, coupons and a customer's price; nothing is ever bought from here.
                    </p>
                    <p v-else class="buy-proxy-package-foot">
                        <v-icon icon="mdi-information-outline" size="14"></v-icon>
                        {{ t('buy.autoExtendNote', { balance: Number(user?.balance || 0).toFixed(2) }) }}
                    </p>

                    <button id="purchaseBtn" type="button" class="hidden"
                        :disabled="!(selectedDetails.country && selectedDetails.isp && selectedDetails.city && selectedPlan && selectedCityHasStock)"
                        data-bs-toggle="modal" data-bs-target="#purchaseModal" aria-hidden="true" tabindex="-1">Purchase</button>
                </div>

            </div>
        </div>

    </div>
    <div>
        <PurchaseModal :preview="adminPreview" :selected-details="selectedDetails" :plan="selectedPlan && plans[selectedPlan]" :selected-server-type="serverType" :openVPN="openVPNTemp" :max-stock="Number(selectedCity?.count || 0)" />
        <NewLocationModal :selected-details="selectedDetails" />
        <NewStockModal :selected-details="selectedDetails" />
    </div>
</template>

<script setup>
import { t } from '@/i18n';
import { countryZh, cityZh } from '@/i18n/places';

import { computed, ref, watch, onMounted, onUnmounted, nextTick, defineProps } from "vue";
import { usePackageStore, useAdminConfigurationStore, useAccountStore } from "@/stores"
import { watchEffect } from "vue";
import { storeToRefs } from "pinia";
import PurchaseModal from "@/components/Customer/BuyNewProxy/PurchaseModal.vue"
import NewLocationModal from "@/components/Customer/BuyNewProxy/NewLocationModal.vue"
import NewStockModal from "@/components/Customer/BuyNewProxy/NewStockModal.vue"
import PackagePlanCard from "@/components/Common/PackagePlanCard.vue"
import StockAlertBox from "@/components/Customer/BuyNewProxy/StockAlertBox.vue"
import FeatureFilterBar from "@/components/Customer/BuyNewProxy/FeatureFilterBar.vue"
// adminPreview: the admin Proxy Stock page shows this same page, so the two can never drift apart. The
// purchase window then runs in preview mode (nothing is bought) and the stock-alert box is left out.
defineProps({ adminPreview: { type: Boolean, default: false } });
const name = process.env.VUE_APP_VUE_NAME;
const backendUrl = process.env.VUE_APP_VUE_SOCKET_URL + "/";
const selectedDetails = ref({ country: null, isp: null, city: null, modems_id: [], ip_version: null, is_ipv6: false });
const adminConfigurationStore = useAdminConfigurationStore();
const packageStore = usePackageStore();
const { countryList, plans } = storeToRefs(packageStore);
const { user } = storeToRefs(useAccountStore());   // balance shown under the plans
const ispList = ref([]);
const cityList = ref([]);
const openVPNTemp = true;
const nextAvailabilityTick = ref(Date.now());
let availabilityTimer = null;

const selectedISP = ref(null)
const selectedPlan = ref(null)

const selectPlan = (planKey) => {
    selectedPlan.value = planKey;
};

const purchasePlan = async (planKey) => {
    selectedPlan.value = planKey;
    await nextTick();
    document.getElementById("purchaseBtn")?.click();
};

const packageOptions = computed(() => {
    return ["daily", "weekly", "monthly"]
        .map((key) => ({ key, plan: plans.value[key] }))
        .filter((option) => option.plan !== null && option.plan !== undefined);
});

const serverType = ref("XProxy");
// await packageStore.getCountryList(serverType.value)



const isIpv6Flag = (value) => value === true || value === 1 || value === '1' || value === 'true';

const ipVersionLabel = (city) => city?.ip_version || (isIpv6Flag(city?.is_ipv6) ? 'IPv6' : 'IPv4');

const cityKey = (city) => `${String(city?.city || '').trim().toLowerCase()}::${ipVersionLabel(city)}`;

const normalizeCityStock = (city) => {
    const isIpv6 = isIpv6Flag(city?.is_ipv6);
    return {
        ...city,
        count: Number(city?.count || 0),
        modem_id: Array.isArray(city?.modem_id) ? [...city.modem_id] : [],
        is_ipv6: isIpv6,
        ip_version: city?.ip_version || (isIpv6 ? 'IPv6' : 'IPv4'),
        next_available_at: city?.next_available_at || null,
    };
};

const firstUpcomingAvailability = (current, incoming) => {
    if (!current) return incoming || null;
    if (!incoming) return current;

    const currentTime = new Date(current).getTime();
    const incomingTime = new Date(incoming).getTime();
    if (Number.isNaN(currentTime)) return incoming;
    if (Number.isNaN(incomingTime)) return current;
    return incomingTime < currentTime ? incoming : current;
};

const mergeCityStockLists = (...lists) => {
    const cityMap = new Map();
    lists.flat().filter(Boolean).map(normalizeCityStock).forEach((city) => {
        const key = cityKey(city);
        const existing = cityMap.get(key);
        if (!existing) {
            cityMap.set(key, city);
            return;
        }

        const modemIds = new Set([...(existing.modem_id || []), ...(city.modem_id || [])]);
        cityMap.set(key, {
            ...existing,
            count: Number(existing.count || 0) + Number(city.count || 0),
            modem_id: [...modemIds],
            next_available_at: firstUpcomingAvailability(existing.next_available_at, city.next_available_at),
        });
    });

    return [...cityMap.values()].sort((a, b) => {
        if (ipVersionLabel(a) !== ipVersionLabel(b)) return ipVersionLabel(a).localeCompare(ipVersionLabel(b));
        return String(a.city || '').localeCompare(String(b.city || ''));
    });
};

const selectedCityKey = computed(() => selectedDetails.value.city ? cityKey(selectedDetails.value) : null);

const selectedCity = computed(() => cityList.value.find((city) => cityKey(city) === selectedCityKey.value));

const selectedCityHasStock = computed(() => Number(selectedCity.value?.count || 0) > 0);

// cities with stock first (most stock at the top), then the sold-out ones, each block A-Z
const byStockThenName = (a, b) => {
    const sa = Number(a?.count || 0) > 0, sb = Number(b?.count || 0) > 0;
    if (sa !== sb) return sa ? -1 : 1;
    if (sa && Number(b.count) !== Number(a.count)) return Number(b.count) - Number(a.count);
    return String(a?.city || '').localeCompare(String(b?.city || ''));
};
const cityGroups = computed(() => [
    { key: 'ipv4', label: 'IPv4', items: cityList.value.filter((city) => ipVersionLabel(city) === 'IPv4').sort(byStockThenName) },
    { key: 'ipv6', label: 'IPv6', items: cityList.value.filter((city) => ipVersionLabel(city) === 'IPv6').sort(byStockThenName) },
].filter((group) => group.items.length > 0));

const defaultIspForList = (items = []) => items.find((isp) => Number(isp?.proxy_count || 0) > 0) || items[0] || null;

const defaultCityForList = (items = []) => items.find((city) => Number(city?.count || 0) > 0) || items[0] || null;

const resetSelectedCity = () => {
    selectedDetails.value.city = null;
    selectedDetails.value.modems_id = [];
    selectedDetails.value.ip_version = null;
    selectedDetails.value.is_ipv6 = false;
    selectedPlan.value = null;
};

const selectDefaultCity = (items = []) => {
    const defaultCity = defaultCityForList(items);
    if (defaultCity) {
        selectCity(defaultCity);
    } else {
        resetSelectedCity();
    }
};

const applyIspList = (items = []) => {
    ispList.value = Array.isArray(items) ? items : [];
    const defaultIsp = defaultIspForList(ispList.value);

    selectedDetails.value.isp = defaultIsp?.isp || null;
    selectedISP.value = defaultIsp?.isp || null;

    if (!defaultIsp) {
        cityList.value = [];
        resetSelectedCity();
    }
};

const formatDuration = (milliseconds) => {
    if (milliseconds <= 0) return 'any time';

    const totalMinutes = Math.ceil(milliseconds / 60000);
    if (totalMinutes <= 5) return '<5 mins';

    const days = Math.floor(totalMinutes / 1440);
    const hours = Math.floor((totalMinutes % 1440) / 60);
    const minutes = totalMinutes % 60;
    const parts = [];

    if (days) parts.push(t('buy.dur.d', { n: days }));
    if (hours) parts.push(t(hours === 1 ? 'buy.dur.hr' : 'buy.dur.hrs', { n: hours }));
    if (!days && minutes) parts.push(t(minutes === 1 ? 'buy.dur.min' : 'buy.dur.mins', { n: minutes }));

    return parts.join(' ') || t('buy.dur.under');
};

const formatNextAvailableTitle = (dateValue) => {
    const date = new Date(dateValue);
    const time = date.getTime();
    if (Number.isNaN(time)) return t('buy.nextExpiry', { time: t('buy.timePending') });

    const formattedDate = new Intl.DateTimeFormat(undefined, {
        month: 'short',
        day: 'numeric',
        hour: 'numeric',
        minute: '2-digit',
    }).format(date);

    return t('buy.nextExpiry', { time: formattedDate });
};

const formatNextAvailable = (dateValue) => {
    const date = new Date(dateValue);
    const time = date.getTime();
    if (Number.isNaN(time)) return t('buy.timePending');

    return formatDuration(time - nextAvailabilityTick.value);
};

watchEffect(async () => {
    await adminConfigurationStore.getOpenvpn()
})


const selectCountry = (countryName) => {
    // if (proxy_count > 0)
    if (selectedDetails.value.country === countryName) {
        selectedDetails.value.country = null
    }
    else {
        selectedDetails.value.country = countryName
    }
}

const selectCity = (city) => {
    // if (proxy_count > 0)
    selectedDetails.value.city = city.city;
    selectedDetails.value.modems_id = Array.isArray(city.modem_id) ? city.modem_id : [];
    selectedDetails.value.ip_version = ipVersionLabel(city);
    selectedDetails.value.is_ipv6 = ipVersionLabel(city) === 'IPv6';
}

// Carriers of a country. "XProxy" is the combined list: X-Proxy, ProxySmart and ProProxyUI stock added together,
// matched by carrier name (the two lists are not always in the same order, or the same length, once a
// feature filter is on).
const loadIsps = async (country, server) => {
    if (!country) { ispList.value = []; cityList.value = []; return; }
    let items = await packageStore.getISPList(country, server) || [];
    if (server === "XProxy") {
        const smart = await packageStore.getISPList(country, 'ProxySmart') || [];
        const ppui = await packageStore.getISPList(country, 'ProProxyUI') || [];
        const byName = new Map();
        for (const isp of [...smart, ...ppui, ...items]) {
            const seen = byName.get(isp.isp);
            if (seen) { seen.proxy_count += Number(isp.proxy_count || 0); seen.isp_image = seen.isp_image || isp.isp_image; seen.max_speed_mbps = seen.max_speed_mbps || isp.max_speed_mbps || null; }
            else byName.set(isp.isp, { isp: isp.isp, proxy_count: Number(isp.proxy_count || 0), isp_image: isp.isp_image, max_speed_mbps: isp.max_speed_mbps || null });
        }
        items = [...byName.values()];
    }
    applyIspList(items);
};

// "Filter proxies by feature": always starts with everything off. A change reloads countries, carriers and cities.
const featureFilter = ref([]);
packageStore.featureFilter = [];
const filterLoaded = ref(true);   // hides the "nothing here" note while a change is still loading
const applyFeatureFilter = async (next) => {
    featureFilter.value = next;
    packageStore.featureFilter = next;
    filterLoaded.value = false;
    // every country stays listed; its number becomes the stock on servers that offer the chosen features
    await packageStore.getCountryList(serverType.value);
    if (!selectedDetails.value.country) selectedDetails.value.country = countryList.value[0]?.name || null;
    // with a filter on, land on something that can be bought: if the country being viewed has no matching
    // stock, move to the first country that has (the carrier and the city then default to ones in stock).
    // When nothing anywhere is in stock, stay where the customer is.
    if (next.length) {
        const stockOf = (country) => Number(country?.x_proxy || 0) + Number(country?.proxysmart || 0) + Number(country?.proproxyui || 0);
        const current = countryList.value.find((country) => country.name === selectedDetails.value.country);
        const firstInStock = countryList.value.find((country) => stockOf(country) > 0);
        if (stockOf(current) === 0 && firstInStock && firstInStock.name !== selectedDetails.value.country) {
            selectedDetails.value.country = firstInStock.name;   // the country watcher loads its carriers and cities
            filterLoaded.value = true;
            return;
        }
    }
    selectedISP.value = null;   // so the city list reloads even when the same carrier is chosen again
    await loadIsps(selectedDetails.value.country, serverType.value);
    filterLoaded.value = true;
};

onMounted(async () => {
    availabilityTimer = window.setInterval(() => {
        nextAvailabilityTick.value = Date.now();
    }, 60000);
    await packageStore.getCountryList(serverType.value)
    selectedDetails.value.country = countryList.value[0]?.name
});

onUnmounted(() => {
    packageStore.featureFilter = [];   // other pages that read stock must not inherit the filter
    if (availabilityTimer) window.clearInterval(availabilityTimer);
});
watchEffect(async () => {
    if (countryList.value?.length === 0){
        await packageStore.getCountryList(serverType.value)
        // countryList.value[1] = countryList.value[0];
        // countryList.value[0] = temp;
        // [countryList.value[0], countryList.value[1]] = [countryList.value[1], countryList.value[0]]
        selectedDetails.value.country = countryList.value[0]?.name
    }

}, [countryList.value])
watch(
    () => selectedDetails.value.country,
    async (newCountry) => { await loadIsps(newCountry, serverType.value) },
    { immediate: true }
);

watch(
    () => serverType.value,
    async (newServer) => { await loadIsps(selectedDetails.value.country, newServer) },
    { immediate: true }
);


watchEffect(async () => {
    if (selectedISP.value) {
        const tempISP = selectedISP.value
        selectedDetails.value.isp = tempISP
        if (selectedDetails.value.country && tempISP) {
            let nextCityList = await packageStore.getCityList(selectedDetails.value.country, tempISP, serverType.value);
            if(serverType.value === "XProxy" ){
                const proxysmartCity = await packageStore.getCityList(selectedDetails.value.country, tempISP, "ProxySmart");
                const proproxyuiCity = await packageStore.getCityList(selectedDetails.value.country, tempISP, "ProProxyUI");
                nextCityList = mergeCityStockLists(nextCityList, proxysmartCity, proproxyuiCity);
            } else {
                nextCityList = mergeCityStockLists(nextCityList);
            }
            cityList.value = nextCityList;
            selectDefaultCity(cityList.value);
        }
    }
}, [selectedISP.value])
watchEffect(() => {
    if (selectedDetails.value.country && selectedDetails.value.isp && selectedDetails.value.city) {
        // emit("detailChoosed", selectedDetails.value)
        packageStore.getPlans(selectedDetails.value.country, selectedDetails.value.isp, selectedDetails.value.city, selectedDetails.value.modems_id).then((res) => {
            if (res){
                selectedPlan.value = Object.keys(res).filter(key => res[key] !== null)[0]
            }
        })
    }
}, [selectedDetails.value.city])

// watchEffect(()=>{
//     packageStore.getCountryList(serverType.value)
// },[serverType.value])
</script>

<style scoped>
/* plan panel in the dashboard palette (was a white box on the dark page) */
.buy-proxy-package-panel { background: var(--ui-page); border: 1px solid var(--ui-line); border-radius: 12px; color: var(--ui-ink); }
.buy-proxy-package-head { display: flex; flex-wrap: wrap; align-items: baseline; justify-content: space-between; gap: 6px 12px; }
.buy-proxy-package-head__title { font-size: 16px; font-weight: 600; color: var(--ui-ink); }
.buy-proxy-package-head__where { font-size: 13px; color: var(--ui-dim); display: inline-flex; align-items: center; gap: 4px; }
.buy-proxy-package-head__where .text-ok { color: var(--ui-teal); }
.buy-proxy-package-head__where .text-warn { color: var(--ui-warn); }
.buy-proxy-package-foot { margin: 12px 0 0; font-size: 13px; color: var(--ui-dim); display: flex; align-items: center; gap: 6px; }
@media (min-width: 1200px) and (max-height: 1080px) {
    .package-section-title {
        padding-top: 2px;
        padding-bottom: 2px;
    }

    .buy-proxy-package-panel {
        padding: 10px !important;
    }

    .buy-proxy-package-grid {
        gap: 6px !important;
    }
}

/* city choices in the same shape and palette as the package cards */
.city-panel { background: var(--ui-page); border: 1px solid var(--ui-line); border-radius: 12px; color: var(--ui-ink); }
.city-group-label { font-size: 12px; letter-spacing: 0.06em; text-transform: uppercase; color: var(--ui-teal); margin: 0 0 8px; font-weight: 600; }
.city-card { position: relative; min-width: 170px; max-width: 260px; min-height: 60px; padding: 12px 16px 12px 14px; border: 1px solid var(--ui-line-strong); border-radius: 12px; background: var(--ui-card-2); color: var(--ui-ink); text-align: left; display: flex; flex-direction: column; justify-content: center; gap: 2px; cursor: pointer; transition: border-color 150ms ease, transform 150ms ease; }
.city-card:hover { border-color: var(--ui-pri-hover); background: var(--ui-card-2-hover); transform: translateY(-1px); }
.city-card.is-selected { border: 2px solid var(--ui-pri); padding: 11px 15px 11px 13px; }
.city-card__name { margin: 0; font-size: 15px; font-weight: 600; line-height: 1.2; padding-right: 52px; }
.city-card__en { margin: 0; font-size: 11.5px; line-height: 1.2; color: var(--ui-dim); padding-right: 52px; }
.city-card__next { margin: 0; font-size: 12px; color: var(--ui-warn); white-space: nowrap; padding-right: 52px; }
.city-card__count { position: absolute; top: 50%; right: 12px; transform: translateY(-50%); min-width: 34px; padding: 3px 9px; border-radius: 999px; font-size: 12px; font-weight: 600; text-align: center; line-height: 18px; }
.city-card__count.is-ok { background: var(--ui-ok); color: var(--ui-badge-ink); }
.city-card__count.is-empty { background: var(--ui-dan); color: var(--ui-badge-ink); }
.feature-filter-empty { margin: 0; color: var(--ui-dim); font-size: 14px; }
.isp-speed { margin-top: 1px; padding: 1px 5px; border-radius: 4px; background: #f59e0b; color: #1f1300; font-size: 9.5px; font-weight: 700; white-space: nowrap; }
</style>
